import { useAuthenticatedSession } from "../../session";
import { PageHeader } from "../../shell";
import { EquipeMembres, membresEsn } from "../equipe/EquipeMembres";

/** Les comptes de l'ESN, pour ses administrateurs. */
export function EsnEquipePage() {
  const { user } = useAuthenticatedSession();
  return (
    <>
      <PageHeader
        eyebrow="Espace ESN"
        title="Équipe ESN"
        description="Les commerciaux créent et suivent les entreprises clientes ; les administrateurs ESN gèrent en plus cette équipe."
      />
      <EquipeMembres membres={membresEsn()} roles={["esn_admin", "commercial"]} selfUserId={user.id} scopeKey="esn" />
    </>
  );
}
